import { Controller } from "@hotwired/stimulus"
import { getJSON, sendJSON, errorDetail } from "../api.js"

// Przełącznik aktywnej organizacji w nawigacji. Widoczny tylko przy > 1 organizacji.
// GET /api/acting-org/ → {acting:{id,name}|null, organizations:[{id,name}]}
// POST /api/acting-org/ {organization:<id>} → 200 + reload | 403 + cofnięcie + komunikat.
export default class extends Controller {
  static values = { url: String }

  async connect() {
    let data
    try {
      data = await getJSON(this.urlValue)
    } catch {
      return
    }
    if (!data.organizations || data.organizations.length <= 1) return

    this._previousId = data.acting ? String(data.acting.id) : null

    const select = document.createElement("select")
    select.className = "ls-select"
    for (const org of data.organizations) {
      const option = document.createElement("option")
      option.value = org.id
      option.textContent = org.name
      if (data.acting && org.id === data.acting.id) option.selected = true
      select.appendChild(option)
    }
    select.addEventListener("change", (e) => this.#onChange(e))

    const errorEl = document.createElement("span")
    errorEl.className = "ls-field-error"
    errorEl.hidden = true

    this._select = select
    this._errorEl = errorEl

    this.element.appendChild(select)
    this.element.appendChild(errorEl)
    this.element.hidden = false
  }

  async #onChange(e) {
    const selectedId = e.target.value
    const previousId = this._previousId
    const res = await sendJSON("POST", this.urlValue, { organization: Number(selectedId) })
    if (res.ok) {
      this.#clearError()
      this._reload()
    } else {
      if (this._select && previousId !== null) this._select.value = previousId
      this.#showError(errorDetail(res.data, "Nie udało się zmienić organizacji."))
    }
  }

  // Seam jawny — testy mogą nadpisać instancyjnie.
  _reload() {
    window.location.reload()
  }

  #showError(msg) {
    if (!this._errorEl) return
    this._errorEl.textContent = msg
    this._errorEl.hidden = false
  }

  #clearError() {
    if (!this._errorEl) return
    this._errorEl.hidden = true
    this._errorEl.textContent = ""
  }
}
